import { Box, VStack } from '@chakra-ui/react';

import { UserCircleIcon } from 'Asset/icon';
import InputComponent from 'UiKit/input';
import { TextRegular } from 'UiKit/typography';
import Tooltip from 'UiKit/tooltip';

import styles from './styles.module.css';

const ChangeSchedule = ({ hostName, schedule, scheduleLabel, titleLabel }) => {
  return (
    <Box position="relative" marginTop={10}>
      <Tooltip label={hostName}>
        <Box className={styles['host__name']}>
          <UserCircleIcon width="24px" height="24px" />
          <TextRegular fontSize="16px">{hostName}</TextRegular>
        </Box>
      </Tooltip>

      <Box flex={1} className={styles['change-schedule']}>
        <VStack spacing={4} align="stretch">
          <InputComponent className={styles['form-reschedule__input']} label={scheduleLabel} value={schedule?.dateTime} isRequired isImmutable />
          <InputComponent className={styles['form-reschedule__input']} label={titleLabel} value={schedule?.title} isRequired isImmutable />
        </VStack>
      </Box>
    </Box>
  );
};

export default ChangeSchedule;
